import { render, staticRenderFns } from "./DTFALists.vue?vue&type=template&id=57ccba0e&"
import script from "./DTFALists.vue?vue&type=script&lang=js&"
export * from "./DTFALists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports